// extracted by css-extract-rspack-plugin
export default {"logo":"Yb_SnC","demoVideo":"hAsO8I"};